import * as constants from './MtEditor.constants';
import * as services from './MtEditor.service';

const state = {
  OSSConfig: {},
};

const mutations = {
  [constants.GET_OSS_POLICY_SUCCESS](state, OSSConfig) {
    state.OSSConfig = OSSConfig;
  },

  [constants.DUMMY_MUTATION]() {
    //
  },
};

const actions = {
  async getQaOssPolicy({ commit }, payload) {
    const res = await services.getQaOssPolicy(payload);
    if (200 === res.data.status) {
      commit(constants.GET_OSS_POLICY_SUCCESS, res.data.data);
    }
  },

  async getNoteOssPolicy({ commit }, payload) {
    const res = await services.getNoteOssPolicy(payload);
    if (200 === res.data.status) {
      commit(constants.GET_OSS_POLICY_SUCCESS, res.data.data);
    }
  },

  async uploadQaImg({ commit }, payload) {
    await services.uploadQaImg(payload.url, payload.data);
    commit(constants.DUMMY_MUTATION);
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
